<template>

    <div class="bottomGather" ref="bottomGather">

        <!--活动-->
        <ActiveModule @click.native.stop="clickActive" v-show="activeshow"></ActiveModule>

        <div class="escape-module iconfont icon-jinjitaosheng" :class="{active:!activeshow}" @click="escapeEvent" v-if="!this.$mapStep.type && $store.state.escapeState"></div>

        <div class="outMapEnter iconfont icon-shiwai2" :class="{bottom:$mapStep.type =='planRoute' && $BRT.$route.selectType.type != 'map' && $mapStep.openQQMapRoute}" v-if="!$mapStep.type || ($mapStep.type =='planRoute' && $BRT.$route.selectType.type != 'map' && $mapStep.openQQMapRoute)" @click="goQQMap">
<!--            <a v-if="!$mapStep.type">室外地图</a>-->
<!--            <a v-else>室外线路</a>-->
        </div>

        <!--全览-->
        <OverviewModule v-if="$mapStep.type == 'planRoute' || $BRT.$NAVTO.NAVType =='NAVINDICATE'"></OverviewModule>


        <!--中间层 楼层 定位 logo-->
        <div class="floor-locate-logo" v-show="$BRT.$NAVTO.NAVType !='NAVINDICATE_END' && poiListState !=3 && !$BRT.$active.shopPoint">

            <!--切换楼层模块-->
            <!--($mapStep.type != 'toNAVING' && $mapStep.type !='planRoute' && $mapStep.type !='toFilter')-->
            <FloorMoudle
                v-show="['toNAVING','planRoute','toFilter'].indexOf($mapStep.type) === -1 ||
                ($mapStep.type =='planRoute' && $BRT.$route.selectType.type == 'map')"></FloorMoudle>

            <!--logo-->
            <LogoMoudle></LogoMoudle>

            <div class="r-quick">
                <!--定位模块-->
                <LocateMoudle v-show="!$BRT.$urlParam.share.status"></LocateMoudle>
            </div>

            <!--缩放模块-->
            <!--<ZoomMoudle></ZoomMoudle>-->

        </div>


        <!--靠底部滑出提示类-->
        <div class="bottom-tips">

            <!--poi信息模块-->
            <PoiInfoMoudle  v-show="$mapStep.type=='selectePOI'"></PoiInfoMoudle>

            <!--导航提示-->
            <NavingTipMoudle v-show="$mapStep.type =='planRoute' || $mapStep.type == 'toNAVING'"></NavingTipMoudle>

            <!--搜索筛选模块-->
            <!--<FilterMoudle></FilterMoudle>-->

            <!--底部推荐模块-->
            <RecommendModule v-if="!$mapStep.type && brtmap.$locate.point && publicFormat && publicFormat.length > 0 && !brtmap.guideView" @on-result = "recomResult"></RecommendModule>

            <!--选择结果楼层-->
            <Dialog class="brt-search-dialog-1" v-model="dialog1" title="选择结果楼层" title-background>
                <ul>
                    <li v-for="(item, index) in formatResult">
                        <span class="l">{{ item.floorName }}</span>
                        <span class="r">
                        <b>{{ item.list.length }}</b>
                        结果
                    </span>
                    </li>
                </ul>
            </Dialog>

            <!--地图底部poi列表筛选-->
            <PoiListDrawer  v-model="poiListState" :data="PoiListData"></PoiListDrawer>

            <!--单店活动-->
            <ShopActiveModule v-if="$mapStep.type == 'shopActive' && $BRT.$active.shopPoint"></ShopActiveModule>

            <!--地图快捷推荐-->
            <BottomQuickModule v-show="!$mapStep.type && brtmap.$locate.point && brtmap.guideView"></BottomQuickModule>

        </div>

    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import FloorMoudle from './modules/FloorModule.vue'
    import LocateMoudle from './modules/LocateModule.vue'
    import BottomQuickModule from './modules/BottomQuickModule.vue'
    import LogoMoudle from './modules/LogoModule.vue'
    import PoiInfoMoudle from './modules/PoiInfoModule.vue'
    import NavingTipMoudle from './modules/NavingTipModule.vue'
    import ActiveModule from './modules/ActiveModule.vue'
    import OverviewModule from './modules/OverviewModule.vue'
    import RecommendModule from './modules/RecommendModule.vue'
    import ShopActiveModule from './modules/ShopActiveModule.vue'
    import { PoiListDrawer } from '@/modules/poiListDrawer'
    import { Dialog } from '@/components/dialog'
    import {_activityPoiExtend,_themeActivityPoiExtend, _detailPoiExtend,CATEGORY_ICONExtend} from "@/utils/search_poi_extend";
    import {getPoiInfo} from "../brtmap/Brtmap";
    import {getMomCare} from '@/config/prepare.js';
    export default {
        name: "BottomGather",

        data(){
            return {
                moduleState:0,      //0初始组件 1选中poi 2已选起终点 3推荐

                //格式化结果
                formatResult: [],
                //选择结果楼层
                dialog1: false,

                //测试poi list
                poiListState: 0,    //  0：隐藏   1：最小化   2：半屏    3：全屏
                PoiListData: {},

            }
        },

        components:{
            FloorMoudle,
            LocateMoudle,
            LogoMoudle,
            // ZoomMoudle,
            PoiInfoMoudle,
            // FilterMoudle,
            NavingTipMoudle,
            ActiveModule,
            OverviewModule,
            RecommendModule,
            ShopActiveModule,
            PoiListDrawer,
            Dialog,
            BottomQuickModule,
        },

        created(){
            this.bus.$off('voiceFilter');
            this.bus.$on('voiceFilter',res=>{
                this.recomResult(res);
            })
        },

        methods:{

            goQQMap(){

                if(!this.$mapStep.type){

                    this.$router.replace('/qqmap');

                }else{

                    //室外路线
                    this.$router.replace({
                        path:'/qqmap',
                        query:{
                            id:0,
                            type:2,
                            vechileIndex:2,
                            model:'routeToLine',
                            enterType:3,    //3地图进入
                            end:JSON.stringify({name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng,address:'广东省深圳市宝安区福海街道'})
                        }
                    })

                }
            },

            shopActiveDeal(){

                let callback = ()=>{
                    //单店活动数据(符合显示店铺处理)
                    if(this.$store.state.ACTIVITY_DATA.length){

                        this.$BRT.$active.shopDatas = {};
                        this.$BRT.$active.shopDatas.floors = [];
                        this.$BRT.$active.shopDatas.total = this.$store.state.ACTIVITY_DATA.length;

                        //按楼层重组数据
                        $VAR.map.mapInfoArray.map($item=>{

                            let $data = [];

                            this.$store.state.ACTIVITY_DATA.map((item)=>{

                                if(item.FLOOR_NUMBER == $item.floorNumber){

                                    let $tags =[];

                                    // item.ACTIVITY_DATA.count.map($$item=>{
                                    //
                                    //     $tags.push({
                                    //         name:$$item.name,
                                    //         content:$$item.content
                                    //     })
                                    //
                                    // })

                                    $data.push({
                                        poi:item.poi,

                                        active:{
                                            title:item.title,
                                            logo:item.shop.logo,
                                            NAME:item.NAME,
                                            distant:0,
                                            slidIMGS:[item.topic],
                                            status:item.status,
                                            tags:$tags,
                                            Data:item
                                        }

                                    })

                                }

                            })

                            if($data.length){
                                this.$BRT.$active.shopDatas.floors.push({
                                    floorName:$item.floorName,
                                    floorNumber:$item.floorNumber,
                                    floorID:$item.floorID,
                                    activeData:$data,
                                });
                            }
                        })

                    }
                }

                if(!this.$mapEventManger.mapQueryStatus){

                    this.$mapEventManger.mapQueryEvents.push(()=>{
                        callback && callback();
                    })

                }

                else{
                    callback && callback();
                }


            },

            clickActive(){

                let plugInSettings = this.$mapStore.plugInfo.plugInfo.plugInSettings;

                if(plugInSettings.themeActivityOpen){
                    this.$router.replace('/activity');
                    this.shopActiveDeal();
                }else{

                    //处理活动店铺
                    this.shopActiveDeal();
                    this.bus.$emit('showShopActive');
                    this.$mapStep.type = 'shopActive';
                }


            },

            escapeEvent(){
                this.$message.info('请您稍等...');
                this.bus.$emit('eacapeBUS',1)
            },

            recomResult(item){

                let $floorId = item.mapID ? '' : item.mapID;

                // console.log('item',item,'$VAR',$VAR);

                let callback = ()=>{

                    $VAR.brtmapSearch.query({
                            type:'name',
                            value: item.name,
                        },
                        (res) => {

                            //防止不规则操作（name与类型不匹配）
                            if(item.CATEGORY_ID){
                                $VAR.brtmapSearch.query({
                                    type:'cid',
                                    value:item.CATEGORY_ID
                                },result=>{

                                    //融合防止遗漏
                                    if(res.length && result.length){

                                        //防止重复
                                        let data = [];
                                        for(let i=0;i<result.length;i++){

                                            if(result[i] && result[i].POI_ID &&
                                                !res.some(item=>{return item.POI_ID == result[i].POI_ID})
                                            ){
                                                data.push(result[i])
                                            }
                                        }

                                        if(data.length){res = res.concat(data);}

                                    }
                                    else if(!res.length && result.length){
                                        res = result;
                                    }

                                })

                            }

                            //出口与出入口问题
                            if(item.name == '出口'){
                                //检索出入口
                                $VAR.brtmapSearch.query({
                                    type:'cid',
                                    value:'150001'
                                },result=>{

                                    //融合防止遗漏
                                    if(res.length && result.length){

                                        //防止重复
                                        let data = [];
                                        for(let i=0;i<result.length;i++){

                                            if(result[i] && result[i].POI_ID &&
                                                !res.some(item=>{return item.POI_ID == result[i].POI_ID})
                                            ){
                                                data.push(result[i])
                                            }
                                        }

                                        if(data.length){res = res.concat(data);}

                                    }else if(!res.length){
                                        res = result;
                                    }
                                })
                            }

                            //排除不可用数据
                            res = res.filter(item=>{
                                let isTrue = true;
                                if(item.CATEGORY_ID.length >= 4 && Math.round(item.CATEGORY_ID) < 1200)isTrue = false;

                                //排除门、大类、不满足的数据
                                return isTrue;
                            });

                            //检查是否有详情poi
                            res = _detailPoiExtend(res, this.$store.state.POI_DETAIL_DATA);

                            //检查是否有活动poi
                            res = _activityPoiExtend(res, this.$store.state.ACTIVITY_DATA);

                            //检查是否有主题活动
                            res = _themeActivityPoiExtend(res,this.$store.state.THEME_ACTIVITY_DATA[0])

                            //类型图标
                            res = CATEGORY_ICONExtend(res);

                            //子节点匹匹配
                            res.map(item=>{

                                if(item.children){
                                    //检查是否有详情poi
                                    item.children = _detailPoiExtend(item.children, this.$store.state.POI_DETAIL_DATA);

                                    //检查是否有活动poi
                                    item.children = _activityPoiExtend(item.children, this.$store.state.ACTIVITY_DATA);

                                    //检查是否有主题活动
                                    item.children = _themeActivityPoiExtend(item.children,this.$store.state.THEME_ACTIVITY_DATA[0])

                                    //类型图标
                                    item.children = CATEGORY_ICONExtend(item.children);
                                }

                            })

                            //排除NAME值为空的数据
                            res = res.filter(item=>{

                                if(item.children){

                                    if(item.children.length)item.children = item.children.filter($item=>{return !!$item.NAME});
                                    return  !!item.NAME && item.children.length

                                }

                                return !!item.NAME;
                            })


                            // //特殊匹配(母婴室)
                            // if(this.$BRT.$urlParam.filter.name == '母婴室' || item.name == '母婴室' || item.name == '母婴' ){
                            //
                            //     getMomCare(this,($momData)=>{
                            //
                            //         $momData = $momData.data.result;
                            //
                            //         //匹配数据
                            //         res.map(item=>{
                            //
                            //             if(item.POI_ID){
                            //
                            //                 let $$data = $momData.filter(($item)=>{return $item.poiId == item.POI_ID})
                            //
                            //                 if($$data.length > 0){
                            //
                            //                     //筛选出可用数据
                            //                     $$data = $$data.filter(($item)=>{ return $item.status == 0})
                            //
                            //                     item.momCare = $$data;
                            //
                            //                 }else{
                            //
                            //                     item.momCare = [];
                            //
                            //                 }
                            //             }
                            //
                            //             if(item.children){
                            //
                            //                 item.children.map($$item=>{
                            //
                            //                     let $$data = $momData.filter(($item)=>{return $item.poiId == $$item.POI_ID})
                            //
                            //                     if($$data.length > 0){
                            //
                            //                         $$data = $$data.filter(($item)=>{ return $item.status == 0})
                            //                         $$item.momCare = $$data
                            //
                            //                     }else{
                            //
                            //                         $$item.momCare = [];
                            //
                            //                     }
                            //                 })
                            //             }
                            //
                            //         })
                            //     })
                            // }
                            //
                            //



                            //筛选条件处理
                            if(this.$BRT.$urlParam.filter.status){

                                let $initShow = this.$BRT.$urlParam.filter.initShow.some((item)=>{return item == this.$BRT.$urlParam.filter.name}),
                                    $locationDo = this.$BRT.$urlParam.filter.location.some((item)=>{return item == this.$BRT.$urlParam.filter.name})

                                if(!($initShow && $locationDo)){ //如果该数据同时又需要初始显示且定位后又需要再次处理，暂不清除

                                    this.$BRT.$urlParam.filter.status = false;
                                    this.$BRT.$urlParam.filter.name = '';
                                }
                            }

                            //附近电梯
                            if(this.$BRT.$urlParam.nearLift.status){
                                this.$BRT.$urlParam.nearLift.status = false;
                            }


                            //数据为空
                            if(res.length == 0){
                                this.$message.info('暂无该数据');
                                this.$message.load(false);
                                return;
                            }



                            //匹配数据
                            let $data=[],$isSetData=false;
                            $data = res.filter(($item)=>{
                                if(!item || item.name !='卫生间'){

                                    if(item.CATEGORY_ID){
                                        return $item.CATEGORY_ID == item.CATEGORY_ID || item.CATEGORY_ID.match($item.CATEGORY_ID)
                                    }else{
                                        return $item.CATEGORY_ID == item.CATEGORY_ID
                                    }

                                }else{
                                    return !item.children
                                }
                            });

                            if($data.length == 0 || $data.length > 1){

                                //防止大类CATEGORY_ID问题(拿单数据，排除大类对象)
                                $data = res.filter(item=>{return !item.children})
                                $isSetData = true;

                                //特殊处理
                                if(!$data.length){

                                    //防止两种大类问题 如：电梯、电梯厅
                                    $data = res.filter(item=>{return item.children});

                                    if($data.length > 1){

                                        $data = $data.filter($item=>{
                                            return $item.NAME == item.name;
                                        });
                                    }

                                    $isSetData = false;

                                }

                            }


                            if(($data.length > 1 && $isSetData) || ($data.length == 1 && $data[0].children && $data[0].children.length > 1)){//重新组装数据


                                if($isSetData){

                                    // console.log('$data',$data);

                                    let obj = {};
                                    obj.CATEGORY_ID =item.CATEGORY_ID;

                                    obj.CATEGORY_ICON = 'https://files.brtbeacon.net/BRTMap/images/'+ item.CATEGORY_ID +'_normal.png';

                                    //自定义特殊处理
                                    if(obj.CATEGORY_ID == '99'){
                                        obj.CATEGORY_ICON = 'https://files.brtbeacon.net/BRTMap/images/'+ $data[0].CATEGORY_ID +'_normal.png'
                                    }

                                    //分类数据处理 00:辅助设施   11:交通服务   15:通行设施    16:公共设施 大类
                                    obj.LEVEL = item.level;
                                    obj.NAME = item.name;
                                    obj.children = $data;
                                    $data=[];

                                    /***************CATEGORY_ID查询不到数据处理***************/
                                    let _callee = (array, id) => {
                                        for (let i = 0; i < array.length; i++) {
                                            if (array[i].value === id) {
                                                return array[i];
                                            }
                                            else {
                                                let obj = _callee(array[i].children, id);
                                                if (obj) {
                                                    return array[i];
                                                }
                                            }
                                        }
                                    };
                                    //防止无效
                                    let classify = _callee(JSON.parse(JSON.stringify($VAR.brtmapSearch._poiTypeCache)), obj.CATEGORY_ID);
                                    if(!classify){obj.CATEGORY_ID = '99';}

                                    /***************CATEGORY_ID查询不到数据处理***************/
                                    $data.push(obj);

                                }

                                $data[0].floorID = $VAR.map.currentMapInfo.floorID; //当前楼层
                                $data[0] = Object.assign({}, $data[0]);

                                //需要切换自动楼层
                                $data[0].changeFloor = item.changeFloor;


                                if(item.resetName){ //重新替换名字
                                    $data[0].NAME = item.resetName;
                                }

                                this.$BRT.$options.PoiListData = $data[0];

                                //筛选数据
                                this.$mapStep.type = 'toFilter';
                                this.$BRT.$filter.open = true;


                            }else{  //单条数据

                                if($data.length){

                                    this.$mapStep.type = '';
                                    setTimeout(()=>{

                                        this.$BRT.$filter.open = true;
                                        this.$mapStep.type = 'selectePOI';
                                        this.$mapStep.poiID = $data[0].POI_ID ? $data[0].POI_ID : $data[0].children[0].POI_ID;
                                        this.bus.$emit('selectedPoint',this.$mapStep.poiID);

                                    },0)

                                }else{
                                    this.$message.info('暂无该数据');
                                    this.$message.load(false);
                                }

                            }

                        });

                }

                if(!this.$mapEventManger.mapQueryStatus){

                    this.$mapEventManger.mapQueryEvents.push(()=>{
                        callback && callback();
                    })

                }

                else{
                    callback && callback();
                }

            },
        },

        watch:{

            $PoiListData(v1,v2){
                this.PoiListData = v1;
                setTimeout(()=>{
                    this.poiListState = 2;
                },300)

            },

            $PoiListDrawer(v1,v2){

                if(v1 ==1 || v1 == 0){
                    this.poiListState = v1;
                }
            },

            poiListState(v1,v2){
                if(v1 != 1){this.$BRT.$options.PoiListDrawer = v1;}
            }

        },

        computed:{
            $PoiListData(){
                return this.$BRT.$options.PoiListData
            },

            $PoiListDrawer(){
                return this.$BRT.$options.PoiListDrawer
            },

            activeshow(){

                let plugInSettings = this.$mapStore.plugInfo.plugInfo.plugInSettings,
                    $ACTIVEDATA = this.$store.state.ACTIVITY_DATA,
                    $OPEN = this.$store.state.THEME_ACTIVITY_DATA_OPEN,
                    $THEMEACTIVELEN = this.$store.state.THEME_ACTIVITY_DATA[0].length +  this.$store.state.THEME_ACTIVITY_DATA[1].length;

                return !this.$mapStep.type && !this.$BRT.$urlParam.share.status && (($OPEN && $THEMEACTIVELEN) || $ACTIVEDATA.length);
            },

            ...mapState({
                brtmap:state=>state.mapStore.brtmap,
                publicFormat:state=>state.RecommendData.publicFormat,
            })
        },

        activated(){
            if(this.$route.query.from=='findCar' && this.$route.query.filterNAME){
                //查数据
                this.recomResult({name:this.$route.query.filterNAME,changeFloor:true})
            }
        },

        mounted(){

            //防止从搜索页进入bug
            if(this.$BRT.$mapStep.type== 'toFilter'){

                this.PoiListData = this.$BRT.$options.PoiListData;

                setTimeout(()=>{
                    this.poiListState = 2;
                },500)

            }


            //初始店铺活动
            if(this.$BRT.$urlParam.shopActive.status){

                //处理活动店铺数据
                this.$BRT.$urlParam.shopActive.status = false;
                this.$mapStep.type = 'shopActive';
                this.shopActiveDeal();
                this.bus.$emit('showShopActive');

            }

            //初始筛选处理 || 周边电梯
            else if(this.$BRT.$urlParam.filter.status || this.$BRT.$urlParam.nearLift.status){

                let _callback = (option) =>{

                    let name = option.name,
                        resetName = option.resetName,
                        mapID = option.mapID,
                        $item = [];

                    //匹配数据
                    if(this.$store.state.RecommendData.publicFormat){

                        $item = this.$store.state.RecommendData.publicFormat.filter((item)=>{
                            return item.name == name;
                        })

                    }

                    if(this.$store.state.RecommendData.businessFormat){

                        if($item.length == 0){
                            //匹配业态数据

                            this.$store.state.RecommendData.businessFormat.map((item)=>{

                                let $data = item.filter(($$item)=>{
                                    return $$item.name == name;
                                })

                                if($data.length >0){$item = $data}

                            })

                        }
                    }


                    // console.log('item1',$item);

                    if($item.length == 0){  //数据不在推荐数据中

                        $item = [{
                            CATEGORY_ID:'99',
                            name:name,
                            level:'',
                            imgUrl:'',
                            priority:'',
                        }]

                    }

                    if(resetName){  //顶部显示
                        $item[0].resetName = resetName;
                    }


                    if(mapID){  //筛选楼层限制
                        $item[0].mapID = mapID;
                    }

                    // console.log('$item[0]',$item[0]);
                    this.recomResult($item[0])

                }

                if(this.$BRT.$urlParam.filter.status){

                    this.bus.$off('getFilter_bus');
                    this.bus.$on('getFilter_bus',(res)=>{

                        //是否需要定位回调执行
                        let $locationDo = this.$BRT.$urlParam.filter.location.some((item)=>{return item == this.$BRT.$urlParam.filter.name})
                        if(!$locationDo)return false;


                        if(!res.status){

                            let item = {

                                resetName:this.$BRT.$urlParam.filter.resetName,

                                name:this.$BRT.$urlParam.filter.name,

                                mapID:res.floor ?  $VAR.map.getFloorInfoByIndex(res.floor).floorID:''

                            }

                            let $locationDo = this.$BRT.$urlParam.filter.location.some((item)=>{return item == this.$BRT.$urlParam.filter.name}),
                                $initShow = this.$BRT.$urlParam.filter.initShow.some((item)=>{return item == this.$BRT.$urlParam.filter.name});

                            if($locationDo && $initShow){

                                if($VAR.map.currentMapInfo.floorNumber != res.floor){

                                    let $zoom = $VAR.map.getZoom();
                                    $VAR.map.setFloor(item.mapID,()=>{
                                        $VAR.map.stop().easeTo({
                                            zoom:$zoom
                                        })
                                    });

                                }else{
                                    //清理防止干扰

                                    this.bus.$emit('colSelectedFloorFilter',res);

                                    // this.$BRT.$urlParam.filter.status = false;
                                    // this.$BRT.$urlParam.filter.name = '';
                                    // this.$BRT.$urlParam.filter.resetName = '';
                                    // this.$message.load(false);

                                }

                            }else{
                                _callback && _callback(item);
                            }

                        }else{

                            //定位失败
                            this.$BRT.$urlParam.filter.status = false;
                            this.$BRT.$urlParam.filter.name = '';
                            this.$BRT.$urlParam.filter.resetName = '';
                            this.$message.load(false);
                            this.$message.info('定位失败，暂无数据');

                        }

                    })

                    /*******初始显示操作*********/
                    let $locationDo = this.$BRT.$urlParam.filter.location.some((item)=>{return item == this.$BRT.$urlParam.filter.name}),
                        $initShow = this.$BRT.$urlParam.filter.initShow.some((item)=>{return item == this.$BRT.$urlParam.filter.name});
                    if(!$locationDo || $initShow){

                        let item = {

                            resetName:this.$BRT.$urlParam.filter.resetName,

                            name:this.$BRT.$urlParam.filter.name,

                            mapID:''

                        }

                        // console.log('item',item);
                        _callback && _callback(item);
                    }


                }

                else{

                    //附近电梯处理
                    this.bus.$off('getNearLift');

                    this.bus.$on('getNearLift',(res)=>{

                        let $nearLift = this.$BRT.$urlParam.nearLift;
                        if(!res.status){

                            let item = {

                                resetName:'周边电梯',

                                name:$nearLift.type == 1 ? '电梯厅':'电梯',

                                mapID: $VAR.map.getFloorInfoByIndex(res.floor).floorID

                            }

                            _callback && _callback(item)

                        }else{

                            //定位失败
                            this.$BRT.$urlParam.nearLift.status = false;
                            this.$message.load(false);
                            this.$message.info('定位失败，暂无数据');

                        }

                        $nearLift.type = 0;

                    });

                }

            }


            //关闭定位视角（导航下不处理）
            document.addEventListener('click',()=>{
                if(this.$BRT.$mapStep.type != 'toNAVING' && this.$BRT.$marker.location && this.$BRT.$marker.location.isFirst){
                    this.bus.$emit('locationView',false);
                }
            })


            let _mapMove = ()=>{

                if(this.poiListState > 0) {this.poiListState = 1}
                //关闭定位视角（导航下不处理）
                if(this.$BRT.$mapStep.type != 'toNAVING' && this.$BRT.$marker.location && this.$BRT.$marker.location.isFirst){
                    this.bus.$emit('locationView',false);
                }
            }

            if(this.$system == 3){

                document.addEventListener('mousedown',(event)=>{
                    var _point1,_point2;
                     _point1 = {x:event.clientX,y:event.clientY};

                    let _callback = ($event)=> {

                        _point2 = {x: $event.clientX, y: $event.clientY};

                        let _d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));
                        if (_d > 300) {
                            _mapMove();
                            document.removeEventListener('mousemove',_callback);
                        }
                    }

                    document.addEventListener('mousemove',_callback);

                    if($overmouse)window.clearTimeout($overmouse);

                    var $overmouse = setTimeout(()=>{

                        document.addEventListener('mouseup',()=>{
                            _point1='', _point2='';
                            document.removeEventListener('mousemove',_callback);
                        });

                    },10)



                })
            }

            else{
                //移动端处理
                document.addEventListener('touchmove',()=>{
                    _mapMove();
                })
            }

            //地图拖动，则筛选列表最小化(不采用地图拖动，会导致地图移动会导致bug)
            // $VAR.map.on('movestart', () => {
            //
            //     if(this.poiListState > 0) {this.poiListState = 1}
            //
            //     //关闭定位视角（导航下不处理）
            //     if(this.$BRT.$mapStep.type != 'toNAVING' && this.$BRT.$marker.location.isFirst){
            //         this.bus.$emit('locationView',false);
            //     }
            //
            // });

        }

    }
</script>

<style lang="less">

    @import "../../../../styles/cssBlock.less";

    .bottomGather{
        .absoluteByCover;
        top: auto;
        pointer-events:none;
        transition: all 0.3s linear;    //划出动画

        /*&.fixed{*/
            /*position: fixed;*/
        /*}*/

        >.escape-module{

            .fixedByCover();
            top: @standartSpaceA4 * 3 + @standartHeightA4 * 2;

            &.active{
                top: @standartSpaceA5 * 2 + @standartHeightA4;
            }

            left: @standartSpaceA4;
            bottom: auto;

            .flexCenter();

            width: @standartHeightA4;
            height: @standartHeightA4;
            border-radius: @standartHeightA4/2;
            background-color: @themeReverseColor;

            font-size: @46px;
            color: @successColor;

            box-shadow: @shadowbox;

            pointer-events: auto;

            &:active{
                background-color: @bodyBgColor;
            }
        }


        >.outMapEnter{

            pointer-events: auto;
            width: @standartHeightA4;
            height: @standartHeightA4;
            border-radius: @radiusNumber;
            box-shadow: @shadowbox;
            .flexCenter();
            background-color: @themeReverseColor;

            margin: 0px 0px @standartSpaceA4  @standartSpaceA4;

            font-size: @66px;

            color: @fontColorA2;

            position: relative;
            z-index: 1;

            &:active{
                background-color: @bodyBgColor;
            }

            &.bottom{
                transform: translateY(100%);
                margin-bottom: 0px;
                border-radius: @standartHeightA4/2;
            }




            /*

            >a{

                pointer-events: auto;
                width: @standartWidthA1;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                word-wrap: break-word;
                writing-mode: vertical-rl;
                writing-mode: tb-rl;
                text-align: center;
                background-color: @themeReverseColor;
                margin-left: @standartSpaceA4;
                margin-bottom: @standartSpaceA4;
                //padding: @standartSpaceA4 0px;
                padding-top: @10px;
                border-radius: @radiusNumber;
                box-shadow: @shadowbox;
                color: @fontColorA2;
                letter-spacing: @10px;

                &:active{
                    background-color: @bodyBgColor;
                }


            }


             */
        }

        >.floor-locate-logo{

            .flexCenter;
            justify-content: flex-start;
            align-items: flex-end;
            margin-bottom: @standartSpaceA5;

            >.r-quick{
                position: relative;
                &.outdoor{
                    position: absolute;
                    right: .32rem;
                }
            }
        }

        .brt-search-dialog-1 {
            pointer-events: auto;
            ul {
                max-height: @500px;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;

                > li {
                    height: @90px;
                    line-height: @90px;
                    color: @fontColorA1;
                    border-bottom: 1px solid @borderColorA3;
                    overflow: hidden;
                    padding: 0 @spacingNumber;

                    &:active {
                        background-color: @activeBgColorA1;
                    }

                    > span {

                        &:first-child {
                            float: left;
                            >span{
                                display: inline-block;
                                height: @standartHeightA1;
                                width: @standartHeightA1;
                                border-radius: @standartHeightA1/2;
                                background-color: var(--themColor);
                                line-height: @standartHeightA1;
                                text-align: center;
                                color: @themeReverseColor;
                            }
                        }
                        &:last-child {
                            float: right;
                            font-size: @normalFontSize - @2px;
                        }

                        > b {
                            font-size: @normalFontSize + @4px;
                            color: var(--themColor);
                        }
                    }
                }
            }
        }
    }

</style>
